import {
  faArrowUpRightFromSquare,
  faCircleQuestion,
} from "@fortawesome/pro-regular-svg-icons";
import { Box } from "@mui/material";

import { Icon } from "@/components/ui-v2";

import { PrimaryNavigationItemBase } from "../../../PrimaryNavigationLinks/components/PrimaryNavigationLink/components/PrimaryNavigationItemBase";

export const HelpCenterButton = () => {
  const startIcon = (
    <Box
      sx={{
        height: 36,
        width: 36,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Icon icon={faCircleQuestion} />
    </Box>
  );

  const endIcon = (
    <Box
      sx={{
        height: 36,
        width: 36,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Icon icon={faArrowUpRightFromSquare} />
    </Box>
  );

  return (
    <PrimaryNavigationItemBase
      as="a"
      icon={startIcon}
      label="Help Center"
      href="https://help.layer.ai/en/"
      target="_blank"
      style={{
        width: "100%",
      }}
    >
      {endIcon}
    </PrimaryNavigationItemBase>
  );
};
